<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center">
      <!-- <div class="button close">
        <span role="button" class="btn" @click="close">
          <IcFalse class="icn lg"/>
        </span>
      </div> -->
      <div class="popup">
        <div class="popup-title">
          <span v-if="common.systemError.type === 'TimeOut'">タイムアウト</span>
          <span v-else>システムエラー</span>
        </div>
        <div class="popup-content">
          <p class="txt" v-if="common.systemError.type === 'TimeOut'">タイムアウトしました。ログイン画面に戻り、ログインし直してください。</p>
          <p class="txt" v-else>申し訳ございません。システムエラーが発生しました。ブラウザを閉じて再度やり直してください。</p>
          <a @click="move" class="txt-blue" role="button" to="/pc/login">ログイン画面へ</a>
          <div class="button mt32"
            v-if="common.systemError.button.show"
            @click="submit"
            >
            <span role="button" class="btn">{{common.systemError.button.text}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    common() {
      return this.$store.state.common
    }
  },
  methods: {
    close() {
      this.$emit('closeSystemError')
    },
    submit() {
      this.$emit('closeSystemError')
      this.$store.dispatch('common/hideError')
    },
    move() {
      this.$emit('closeSystemError')
      this.$store.dispatch('common/hideError')
      this.$router.push({ path: '/pc/login'})
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup {
    &-title {
      background-color: $color-link;
      padding: 32px 40px!important;
      color: #fff;
      border-radius: 8px 8px 0 0;
      font-size: 2.4rem;
    }
  }
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
